<template>
	<div class='VideoList'>
		<h3 class="title">
			视频列表
		</h3>
		<div class="item_box">
			<div class="item" v-for="(item, index) in page_data" :key="index">
				<div class="info_time">
					<span><i class="iconfont">&#xe67f;</i> {{item.create_time, 'Y年M月D日 h:m:s'| formatDates}}</span>
				</div>

				<div class="content">
					<vue-aliplayer-v2
						class="VueAliplayerV2Style"
						:data-ref="`VueAliplayerV2_${index}`"
						:ref="`VueAliplayerV2_${index}`"
						:options="{...videoOptions, cover: item.videoPic}"
						:source="item.url"
						@play="onPlay"
						@ready="handleVideoReady"
					/>
					<div class="desc">{{item.abstracts}}</div>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
import ShareServiceList from "../../../service/ShareServiceList";
import { formatDates } from '@/assets/js/date.js';

export default {
	name: "VideoList",
	components: {},
	data() {
		return {
			page_data: null,
			videoOptions: {
				autoplay: false,
			}
		};
	},
	/* 时间过滤 */
    filters: {
      formatDates
    },
	async mounted() {
		const list = await new ShareServiceList().videoListData(
			this.$route.query.id
		);

		this.page_data = list;
	},
	methods: {
		onPlay(e){
			const dataIndex = e.target.dataset.ref

			Object.keys(this.$refs).forEach(key => {
				if(key.indexOf('VueAliplayerV2') > -1 && key != dataIndex){
					this.$refs[key][0].pause()
				}
			})
		},
		handleVideoReady(e){
			// console.log('e: ', e)
			console.log('handleVideoReady')
			// const cover_img = e.target.getAttribute('cover')
			// e.target.__vue__.setCover(cover_img)
		}
	},
};
</script>
<style lang='stylus' scoped>
.VideoList
	width 100%
	padding-bottom: 0.8rem

	.title
		width: calc(100% - 1.34rem)
		text-align: left;
		border-left: 5px solid #0098f9;
		margin 0.34rem auto
		padding-left: 10px;
		overflow: hidden;
		font-size: 32px;
		color: #333;
		font-weight: 600;
		line-height: 35px;

		.right_status
			background: #fe6333;
			padding: 2px 10px;
			border-radius: 10px;
			color: #FFF;
			display: block;
			font-size: 24px;
			float: right;

	.item_box
		width calc(100% - 1.34rem)
		margin auto
		padding-top: 0.34rem
		box-shadow: 3px 2px 15px #999;

		.item
			width: 100%;
			border-left: 2px solid #1994fb;/*no*/

			.info_time
				width: 100%;

				span
					background: #1994fb;
					padding: 4px 30px 4px 10px;
					color: #FFF;
					border-top-right-radius: 20px;
					border-bottom-right-radius: 20px;
					font-size: 28px;
					display: inline-block;

					i
						font-size: 28px;

			.content
				text-indent: 2em
				width calc(100% - 1.34rem)
				margin auto
				padding 0.4rem 0

				img,p
					width calc(100% - 1.34rem)
					margin auto

				.desc
					font-size: 0.32rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					line-height: 0.64rem;
					color: #333;
					margin-top: 0.4rem

				.VueAliplayerV2Style
					width 100%
					height 5.33rem !important
					// background-color unset !important
					display flex
					justify-content: space-around
					align-items: center

					>>>.prism-big-play-btn
						position unset !important
						left unset
						display flex
						justify-content: space-around
						align-items: center

						.outter
							position unset


@media (min-width 750px)
	body
		width 750px
		margin auto
		overflow hidden
</style>
